import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { AuthService } from '../services/auth.service';

@Component({
  selector: 'app-noaccess',
  templateUrl: 'noaccess.component.pug',
  styleUrls: ['./noaccess.component.sass']
})
export class NoAccessComponent {

  constructor(private location: Location, private authService: AuthService) {

  }
}



// WEBPACK FOOTER //
// ./src/app/unauthorized/noaccess.component.ts